<template>
    <div class="time-picker" v-click-outside="hide">
        <span v-if="isDuration" class="inputHolder">
            <input :disabled="disabled" type="text" class="display-time full" v-model="timestamp" @click.stop="toggleDropdown" @blur="update" @keypress.enter="updateAndClose">
        </span>
        <span v-else  class="inputHolder">
            <input :disabled="disabled" type="text" class="display-time full" v-model="timestamp" @click.stop="toggleDropdown" @blur="update" @keypress.enter="updateAndClose">
        </span>

        <div class="dropdown" :class="{showOnTop: showOnTop}" v-if="showDropdown">
            <div class="select-list">
                <ul class="hours">
                    <li class="hint">{{ hourHint }}</li>
                    <li v-for="h in availableHours" :class="{ active: hours === h }" @click.stop="changedHours(h)">{{ h }}</li>
                </ul>

                <ul class="minutes">
                    <li class="hint">{{ minuteHint }}</li>
                    <li v-for="m in availableMinutes" :class="{active: minutes === m}" @click.stop="changedMinutes(m)">{{ m }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            defaultTime: {
                type: Array,
                required: false
            },
            availableHours: {
                type: Array,
                default: function() { return ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'] }
            },
            availableMinutes: {
                type: Array,
                default: function() { return ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'] }
            },
            isDuration: {
                type: Boolean,
                default: false
            },
            showOnTop: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {
                showDropdown: false,
                hours: '09',
                minutes: '00',
                hourHint: 'Hours',
                minuteHint: 'Min',
            }
        },
        watch: {
            defaultTime: function (newValue, oldValue) {
                this.hours = this.defaultTime[0];
                this.minutes = this.defaultTime[1];
                // this.$emit('change', this.timestamp);
            }
        },
        created: function() {
            if (this.defaultTime) {
                this.hours = this.defaultTime[0];
                this.minutes = this.defaultTime[1];
            }
        },
        computed: {
            timestamp: {
                get() {
                    return this.hours + ':' + this.minutes;
                },
                set(value) {
                    const parts = value.split(':');
                    this.hours = parts[0];
                    this.minutes = parts[1];
                }
            }
        },
        methods: {
            hide: function() {
                this.showDropdown = false;
            },
            changedHours: function(val) {
                this.hours = val;
                this.$emit('change', this.timestamp = `${val}:${this.minutes}`);
            },
            changedMinutes: function(val) {
                this.minutes = val;
                this.$emit('change', this.timestamp = `${this.hours}:${val}`);
            },
            toggleDropdown: function() {
                this.showDropdown = !this.showDropdown;
            },
            updateAndClose: function(e) {
                this.update(e);
                this.toggleDropdown();
            },
            update: function(e) {
                var pieces = e.target.value.split(':');

                this.hours = pieces[0].padStart(2, '0');

                if( !(_.includes(this.availableHours, this.hours))) {
                    this.hours = this.availableHours[0];
                }

                this.minutes = pieces[1].padEnd(2, '0');

                this.$emit('change', this.timestamp);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .dropdown { 
        min-width: 120px;
    }
</style>



// WEBPACK FOOTER //
// Timepicker.vue?1b2b5432